export default __webpack_public_path__ + "static/media/RC.92f477e7.png";